import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { USERS_PATH } from '../shared/constants';
import { UsersComponent } from './users.component';

const routes: Routes = [
  {
    path: USERS_PATH,
    component: UsersComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
